/**
 * Convert a base64 string in a Blob according to the data and contentType.
 *
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */
const b64toBlob = (b64Data: string, contentType: string, sliceSize?: number) => {
  const mimeType = contentType || '';
  const sizeOfSlice = sliceSize || 512;

  const byteCharacters = atob(b64Data);
  const byteArrays: Uint8Array[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sizeOfSlice) {
    const slice = byteCharacters.slice(offset, offset + sizeOfSlice);

    const byteNumbers: number[] = [];
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays as any, { type: mimeType });
};

export const dataURLtoFile = (dataURL: string, filename: string) => {
  const arr: any = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while ((n -= 1)) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const dataURItoBlob = (dataURL: string) => {
  // Split the base64 string in data and contentType
  const block = dataURL.split(';');

  // Get the content type of the image
  const contentType = block[0].split(':')[1];

  // get the real base64 content of the file
  const realData = block[1].split(',')[1];

  return b64toBlob(realData, contentType);
};
